import http from "../utils/http-common";

class TiresTypeDataService {
  getAll() {
    return http.get("/tires-type");
  }

  get(id) {
    return http.get(`/tires-type/${id}`);
  }

  create(data) {
    return http.post("/tires-type", data);
  }

  update(id, data) {
    return http.put(`/tires-type/${id}`, data);
  }

  delete(id) {
    return http.delete(`/tires-type/${id}`);
  }
}

export default new TiresTypeDataService();
